export default "__VITE_ASSET__5127a25c__"